import GreyCircle from 'assets/images/grey-circle.svg';
import RedCircle from 'assets/images/red-circle.svg';
import { noResultsText } from '../constants';

const nonOutlierRmGraphic = {
    image: {
        type: 'image',
        style: {
            image: GreyCircle
        },
        cursor: 'default',
        bottom: '3.5%',
        width: 12,
        height: 12,
        top: '94.5%',
        left: '33.5%'
    },
    text: {
        type: 'text',
        style: {
            text: 'Non-outlier RM',
            font: '12px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        bottom: 10,
        left: '36.5%'
    }
};

const outlierRmGraphic = {
    image: {
        type: 'image',
        style: {
            image: RedCircle
        },
        cursor: 'default',
        bottom: 23,
        top: '94.5%',
        left: '53.5%'
    },
    text: {
        type: 'text',
        style: {
            text: 'Outlier RM',
            font: '12px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        bottom: 10,
        left: '56.5%'
    }
};
export const scenarioTwoStackedBarChartOptions = (data) => {
    const isThereData =
        data &&
        (!!data.totalOutlierConcentration ||
            !!data.totalNonOutlierConcentration ||
            !!data.totalOutlierPortfolio ||
            !!data.totalNonOutlierPortfolio);
    return {
        title: {
            left: 'left',
            text: 'Breach Category',
            textStyle: {
                color: '#244B60',
                fontSize: '12px'
            }
        },
        xAxis: {
            data: isThereData
                ? [
                      {
                          value: 'Concentration Risk',
                          textStyle: {
                              fontWeight: 400,
                              fontSize: 10
                          }
                      },
                      {
                          value: 'Portfolio Risk Mismatch',
                          textStyle: {
                              fontWeight: 400,
                              fontSize: 10
                          }
                      }
                  ]
                : [],
            name: 'Breach Category',
            nameLocation: 'center',
            nameGap: 45,
            nameTextStyle: {
                color: '#7FADBF',
                fontWeight: 600,
                fontSize: 12,
                width: '100%',
                verticalAlign: 'middle'
            },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
            splitArea: { show: false }
        },
        yAxis: {
            name: '# of RMs',
            nameLocation: 'center',
            nameGap: 90,
            nameTextStyle: {
                color: '#7FADBF',
                fontWeight: 600,
                fontSize: 12,
                width: '100%',
                verticalAlign: 'middle'
            },
            splitLine: { show: false },
            axisLabel: { show: false }
        },
        grid: {
            width: '65%',
            left: '20%',
            top: '75px',
            height: '250px'
        },
        series: [
            {
                name: 'bar',
                type: 'bar',
                stack: 'one',
                barWidth: '50%',
                barGap: '4px',
                barCategoryGap: '4px',
                emphasis: {
                    itemStyle: {
                        color: '#929292'
                    },
                    focus: 'self',
                    blurScope: 'global'
                },
                blur: {
                    label: {
                        show: true,
                        color: 'black',
                        fontSize: 14,
                        fontWeight: 400
                    },
                    itemStyle: {
                        color: '#929292',
                        opacity: 0.3
                    }
                },
                itemStyle: {
                    cursor: 'default',
                    color: '#CECECE'
                },
                label: {
                    show: true,
                    color: '#FFFFFF',
                    fontSize: 14,
                    fontWeight: 400
                },
                data:
                    data &&
                    (data.totalNonOutlierConcentration ||
                        data.totalNonOutlierPortfolio)
                        ? [
                              data.totalNonOutlierConcentration === 0
                                  ? null
                                  : data.totalNonOutlierConcentration,
                              data.totalNonOutlierPortfolio === 0
                                  ? null
                                  : data.totalNonOutlierPortfolio
                          ]
                        : [],
                cursor: 'default'
            },
            {
                name: 'bar2',
                type: 'bar',
                stack: 'one',
                emphasis: {
                    itemStyle: {
                        color: '#EB4560'
                    },
                    focus: 'self',
                    blurScope: 'global'
                },
                blur: {
                    label: {
                        show: true,
                        color: 'black',
                        fontSize: 14,
                        fontWeight: 400
                    },
                    itemStyle: {
                        color: '#EB4560',
                        opacity: 0.3
                    }
                },
                itemStyle: {
                    cursor: 'default',
                    color: '#EB4560'
                },
                label: {
                    show: true,
                    color: '#FFFFFF',
                    fontSize: 14,
                    fontWeight: 400
                },
                data:
                    data &&
                    (data.totalOutlierConcentration ||
                        data.totalOutlierPortfolio)
                        ? [
                              data.totalOutlierConcentration === 0
                                  ? null
                                  : data.totalOutlierConcentration,
                              data.totalOutlierPortfolio === 0
                                  ? null
                                  : data.totalOutlierPortfolio
                          ]
                        : [],
                cursor: 'default'
            }
        ],
        graphic: isThereData
            ? [
                  nonOutlierRmGraphic.image,
                  nonOutlierRmGraphic.text,
                  outlierRmGraphic.image,
                  outlierRmGraphic.text
              ]
            : [
                  nonOutlierRmGraphic.image,
                  nonOutlierRmGraphic.text,
                  outlierRmGraphic.image,
                  outlierRmGraphic.text,
                  noResultsText
              ]
    };
};
